/* eslint-disable react/no-array-index-key */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import './BreadCrumb.sass';

class BreadCrumb extends Component {
  constructor(props) {
    super(props);
    this.handlePushHistory = this.handlePushHistory.bind(this);
  }

  handlePushHistory(route) {
    const { history } = this.props;
    history.push(route);
  }

  render() {
    const { data, style, delimiter } = this.props;

    const renderBreadCrumbs = data.map((crumb, id) => (
      <span className="crumb-element" key={id}>
        <a onClick={() => this.handlePushHistory(crumb.path)}>{ crumb.value }</a> { delimiter }
      </span>
    ));

    return (
      <div className="BreadCrumb" style={style}>
        { renderBreadCrumbs }
      </div>
    );
  }
}

BreadCrumb.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired
  })),
  style: PropTypes.object,
  delimiter: PropTypes.any,
  history: PropTypes.object.isRequired
};

BreadCrumb.defaultProps = {
  data: [{ value: 'Hello', path: '/' }, { value: 'World', path: '/' }],
  style: {},
  delimiter: <span className="fa fa-angle-double-right" />
};

export default withRouter(BreadCrumb);



// WEBPACK FOOTER //
// ./src/components/BreadCrumb.jsx